export enum Clients {
  BRIDGET = 'BRIDGET',
  JIMBO = 'JIMBO',
}
